module.exports = __webpack_public_path__ + "img/image6.0aeceafc.png";